import React from 'react';
import SignUpPane from '../signup/SignUpPane';
import './Welcome.css';

export default function WelcomeSignUp() {
  
  return (
    <div className='landing'>
      <SignUpPane />
    </div>
  )
}
